import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useState, useRef, useEffect} from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import HandymanIcon from '@mui/icons-material/Handyman';
import BatchPredictionIcon from '@mui/icons-material/BatchPrediction';
import HideAppBar from '../../components/hide-app-bar';
import Banner from '../banner';
import About from '../about';
import Organizations from '../organizations';
import Works from '../work';
import Skills from '../skills';
import Footer from '../footer';

interface PropsGetActiveModule {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    active:number
}


function GetActiveModule(props: PropsGetActiveModule){

    switch(props.active){
        case 0:
            return <Banner isMobile={true} />
        case 1:
            return <About isMobile={true} />
        case 2:
            return <Organizations isMobile={true}/>
        case 3:
            return <Works isMobile={true}/>
        case 4:
            return <Skills isMobile={true} />
        default:
            return <></>
    }

}



export default function BottomNav(){
    

    const [value, setValue] = useState(0);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        (ref.current as HTMLDivElement).ownerDocument.body.scrollTop = 0;
    }, [value]);



    return(
        <Box sx={{ pb: 7 }} ref={ref}>
            <HideAppBar children={<></>}/>
            <GetActiveModule active={value} />
            <Paper  sx={{ position: 'fixed', bottom: 0, left: 0, right: 0,}} elevation={3}>
                <BottomNavigation 
                    sx={{ width: "100%",
                        '& .Mui-selected': {
                            '& .MuiSvgIcon-root, & .MuiBottomNavigationAction-label': {
                                color: '#fff'
                            }
                        }
                        }} 
                    value={value} 
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    
                    >
                    <BottomNavigationAction 
                        label="Home" icon={<HomeIcon />} />
                    <BottomNavigationAction label="About" icon={<PersonIcon />} />
                    <BottomNavigationAction label="Organization" icon={<CorporateFareIcon />} />
                    <BottomNavigationAction label="Works" icon={<BatchPredictionIcon />} />
                    <BottomNavigationAction label="Skills" icon={<HandymanIcon />} />
                </BottomNavigation>
            </Paper>
        </Box>
    );

}


